module.exports = __webpack_public_path__ + "src/assets/img/pig-head.e0785262.svg";